<template>
    <Dialog
        :value="true"
        :header-text="$t('Change')"
        :width="350"
        persistent
        hide-close-icon
        fixed
        @close_modal="$emit('close')"
    >
        <text-area-field
            :max-length="50"
            :value="localComment"
            :label="$t('Comment')"
            autofocus
            @input="localComment = $event"
        />
        <template slot="footer">
            <v-spacer />
            <secondary-button @click="$emit('close')">
                {{ $t('Cancel') }}
            </secondary-button>
            <primary-button
                :loading="loader.isLoading"
                @click="onSave"
            >
                {{ $t('Save') }}
            </primary-button>
        </template>
    </Dialog>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import { computed, ref, watch, reactive } from "@vue/composition-api";
import Dialog from "@/components/Dialog";
import ApiFlexTime from "@/api/report/flextime";
import {formatTimeDuration, parseTimeDuration} from "@/plugins/formatting";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import Loader from "@/utility/loader";

export default {
    name: "ReportChangeFlextimeCommentModal",
    components: {
        Dialog
    },
    props: {
        comment: {
            type: String,
            default: null
        },
        flextimeId: {
            type: Number,
            required: true
        }
    },
    setup(props, ctx) {
        const localComment = ref(props.comment);
        const loader = reactive(new Loader());

        const onSave = async () => {
            ctx.emit('update-comment', localComment.value)
            ctx.emit('close')
        }

        return {
            onSave,
            loader,
            localComment
        }
    }
}
</script>
